import React from 'react'

export const DefaultPanel = () => {
  return <div />
}

export default DefaultPanel
